<script>
import orBreak from "../common/orBreak.vue";

export default {
  name: "equipment-table",
  components: {
    orBreak,
  },
  props: {
    items: Array,
    hideCosts: Boolean,
  },
  data: () => ({
    localItems: [],
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: "Item",
        align: "start",
        value: "ItemId",
      },
      { text: "Description", value: "Description" },
      { text: "Quantity", value: "NumberOfCrew" },
      { text: "Included in Day Rate", value: "IncludedInDayRate", align: "center" },
      { text: "Cost", value: "Cost", align: "right" },
      { text: "Mob", value: "MobilisationCost", align: "right" },
      { text: "Demob", value: "DemobilisationCost", align: "right" },
      { text: "Comment", value: "Comment" },
      { text: "", value: "actions", sortable: false, align: "right" },
    ],
    headersRequirement: [
      {
        text: "Item",
        align: "start",
        value: "ItemId",
      },
      { text: "Description", value: "Description" },
      { text: "Quantity", value: "NumberOfCrew" },
      { text: "Comment", value: "Comment" },
      { text: "", value: "actions", sortable: false, align: "right" },
    ],
    editedIndex: -1,
    editedItem: {
      ItemId: "",
      Category: "",
      Description: "",
      NumberOfCrew: null,
      IncludedInDayRate: false,
      Cost: null,
      Currency: "",
      MobilisationCost: null,
      MobilisationCurrency: "",
      MobilisationCostText: "",
      DemobilisationCost: null,
      DemobilisationCurrency: "",
      DemobilisationCostText: "",
      Comment: "",
    },
    defaultItem: {
      ItemId: "",
      Category: "",
      Description: "",
      NumberOfCrew: null,
      IncludedInDayRate: false,
      Cost: null,
      Currency: "",
      MobilisationCost: null,
      MobilisationCurrency: "",
      MobilisationCostText: "",
      DemobilisationCost: null,
      DemobilisationCurrency: "",
      DemobilisationCostText: "",
      Comment: "",
    },
    allCurrencies: [],
    allCategories: [],
    defaultDescriptions: [],
    requiredRule: [(v) => !!v || "Required"],
    hasMobilisationCost: false,
    hasDemobilisationCost: false,
  }),
  methods: {
    orderItemsByCategory(items) {
      if (!items || !items.length) {
        return [];
      }
      items.sort(this.compare);
      return items;
    },
    compare(a, b) {
      var cats = this.allCategories.map(function(x) {
        return x.Key;
      });
      if (cats.indexOf(a.Category) < cats.indexOf(b.Category)) {
        return -1;
      } else if (cats.indexOf(a.Category) > cats.indexOf(b.Category)) {
        return 1;
      } else {
        return 0;
      }
    },
    updateItems() {
      this.$emit("update:items", this.localItems);
    },
    editItem(item) {
      this.editedIndex = this.localItems.indexOf(item);
      this.editedItem = Object.assign({}, item);

      if (this.editedItem.MobilisationCost || this.editedItem.MobilisationCostText) {
        this.hasMobilisationCost = true;
      } else {
        this.hasMobilisationCost = false;
      }

      if (this.editedItem.DemobilisationCost || this.editedItem.DemobilisationCostText) {
        this.hasDemobilisationCost = true;
      } else {
        this.hasDemobilisationCost = false;
      }

      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.localItems.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.localItems.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.isValid()) {
        if (this.editedIndex > -1) {
          var exist = this.localItems[this.editedIndex];
          if (exist.Category != this.editedItem.Category) {
            this.editedItem.ItemId = this.getItemId(this.editedItem);
          }
          Object.assign(exist, this.editedItem);
        } else {
          this.editedItem.ItemId = this.getItemId(this.editedItem);
          this.localItems.push(this.editedItem);
        }
        this.updateItems();
        this.close();
      }
    },
    async getCurrencies() {
      this.allCurrencies = await this.$store.dispatch("getRequest", { controller: "lookup", method: `GetCurrencyTypesShort` });
    },
    async getCategories() {
      this.allCategories = await this.$store.dispatch("getRequest", { controller: "lookup", method: `GetAllCostBreakdownCategories` });
    },
    async getDefaultDescriptionsByCategory(category) {
      this.defaultDescriptions = await this.$store.dispatch("getRequest", { controller: "lookup", method: `GetDescriptionsByCostBreakdownCategory`, parameters: { category: category } });
    },
    getCurrencyGap(currency) {
      var symbol = this.getCurrencySymbol(currency);
      if (symbol == "CAD" || symbol == "NOK" || symbol == "DKK") {
        return " ";
      } else {
        return "";
      }
    },
    getDisplayCost(item) {
      if (item.Cost && item.Currency) {
        var currency = this.getCurrencySymbol(item.Currency);
        return `${this.getCurrencySymbol(item.Currency)}${this.getCurrencyGap(item.Currency)}${numberWithCommas(item.Cost)}`;
      } else {
        if (item.IncludedInDayRate) {
          return "-";
        } else {
          return "TBA";
        }
      }
    },
    getDisplayMobilisationCost(item) {
      if (item.MobilisationCurrency && item.MobilisationCost) {
        return `${this.getCurrencySymbol(item.MobilisationCurrency)}${this.getCurrencyGap(item.MobilisationCurrency)}${numberWithCommas(item.MobilisationCost)}`;
      } else if (item.MobilisationCostText) {
        return item.MobilisationCostText;
      } else {
        return "-";
      }
    },
    getDisplayDemobilisationCost(item) {
      if (item.DemobilisationCurrency && item.DemobilisationCost) {
        return `${this.getCurrencySymbol(item.DemobilisationCurrency)}${this.getCurrencyGap(item.DemobilisationCurrency)}${numberWithCommas(item.DemobilisationCost)}`;
      } else if (item.DemobilisationCostText) {
        return item.DemobilisationCostText;
      } else {
        return "-";
      }
    },
    getCurrencySymbol(currencyValue) {
      if (currencyValue && this.allCurrencies.length) {
        return this.allCurrencies.filter(function(x) {
          return x.Key == currencyValue;
        })[0].Value;
      } else {
        return "";
      }
    },
    isValid() {
      return this.$refs.form.validate();
    },
    getItemId(item) {
      if (this.localItems) {
        var countByCategory = this.localItems.filter(function(x) {
          return x.Category == item.Category;
        });
        var thisItem = 1;
        if (countByCategory && countByCategory.length) {
          thisItem = countByCategory.length + 1;
        }
        var categoryIdentity = this.getCategoryIdentifier(item.Category);
        return `${categoryIdentity}-${thisItem}`;
      } else {
        return "";
      }
    },
    getCategoryIdentifier(category) {
      return category
        .split(" ")
        .map(function(x) {
          return x[0];
        })
        .join("");
    },
    sortedtest(blah) {
      console.log(blah);
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Add Item" : "Edit Item";
    },
    showCrewQuantity() {
      var activeCategory = this.editedItem.Category;
      return (
        activeCategory == "Vessel Marine Manning" || activeCategory == "Survey Manning" || activeCategory == "ROV Manning" || activeCategory == "Project Manning" || activeCategory == "Other Manning"
      );
    },
    getHeaders() {
      if (this.hideCosts) {
        return this.headersRequirement;
      } else {
        return this.headers;
      }
    },
  },

  watch: {
    items(val) {
      this.localItems = val ? val : [];
    },
    localItems: {
      deep: true,
      handler(val) {
        this.$emit("update:items", val);
      },
    },
    dialog(val) {
      val || this.close();
      if (val && this.editedIndex == -1) {
        this.$refs.form.reset();
      }
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    hasMobilisationCost(val) {
      if (!val) {
        this.editedItem.MobilisationCost = null;
        this.editedItem.MobilisationCurrency = "";
        this.editedItem.MobilisationCostText = "";
      }
    },
    hasDemobilisationCost(val) {
      if (!val) {
        this.editedItem.DemobilisationCost = null;
        this.editedItem.DemobilisationCurrency = "";
        this.editedItem.DemobilisationCostText = "";
      }
    },
    "editedItem.Category"(val) {
      this.getDefaultDescriptionsByCategory(val);
    },
    "editedItem.IncludedInDayRate"(val) {
      if (!val) {
        this.editedItem.Currency = null;
        this.editedItem.Cost = null;
      }
    },
  },

  async mounted() {
    this.localItems = this.items ? this.items : [];
    await this.getCategories();
    await this.getCurrencies();
  },
};
</script>
<template>
  <v-data-table :headers="getHeaders" group-by="Category" :custom-sort="orderItemsByCategory" :items="localItems" class="elevation-1">
    <template v-slot:top>
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
              Add Item
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-form ref="form">
                <v-row>
                  <v-col cols="12">
                    <v-select
                      dense
                      hide-details="auto"
                      v-model="editedItem.Category"
                      item-text="Value"
                      item-value="Key"
                      :items="allCategories"
                      outlined
                      label="Category"
                      :rules="requiredRule"
                    ></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-combobox
                      hide-details
                      dense
                      outlined
                      v-model="editedItem.Description"
                      :items="defaultDescriptions"
                      label="Description"
                      @input.native="editedItem.Description = $event.srcElement.value"
                    ></v-combobox>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      hide-details="auto"
                      dense
                      outlined
                      type="number"
                      v-model.number="editedItem.NumberOfCrew"
                      hint="Leave blank if TBA"
                      persistent-hint
                      :label="showCrewQuantity ? 'Number of Personnel' : 'Quantity'"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-0" v-if="!hideCosts">
                    <span class="primary--text text-subtitle">Day Rate <span v-if="showCrewQuantity">(per person)</span><span v-else>(per item)</span></span>
                    <br />
                    <i>(Leave blank if TBA)</i>
                  </v-col>
                  <v-col cols="12" v-if="!editedItem.IncludedInDayRate && !hideCosts" class="py-0">
                    <v-row>
                      <v-col cols="6">
                        <v-select dense hide-details="auto" v-model="editedItem.Currency" item-text="Value" item-value="Key" :items="allCurrencies" outlined label="Currency"></v-select>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field hide-details dense outlined type="number" v-model.number="editedItem.Cost" label="Rate"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="py-0" v-if="!editedItem.IncludedInDayRate && !hideCosts">
                    <or-break></or-break>
                  </v-col>
                  <v-col cols="12" class="pt-0" v-if="!hideCosts">
                    <v-checkbox label="Included in Day Rate" dense hide-details v-model="editedItem.IncludedInDayRate"></v-checkbox>
                  </v-col>

                  <v-col cols="12" class="py-0" v-if="!hideCosts">
                    <span class="primary--text text-subtitle">Mobilisation</span>
                  </v-col>
                  <v-col cols="12" class="py-0" v-if="!hideCosts">
                    <v-checkbox label="Mobilisation" dense hide-details v-model="hasMobilisationCost"></v-checkbox>
                  </v-col>
                  <v-col cols="12" class="pt-0" v-if="hasMobilisationCost && !hideCosts">
                    <v-row>
                      <v-col cols="6">
                        <v-select
                          dense
                          hide-details="auto"
                          v-model="editedItem.MobilisationCurrency"
                          item-text="Value"
                          item-value="Key"
                          :items="allCurrencies"
                          outlined
                          label="Mob Currency"
                        ></v-select>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field hide-details dense outlined type="number" v-model.number="editedItem.MobilisationCost" label="Mob Cost"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" v-if="hasMobilisationCost && !hideCosts">
                    <v-textarea hide-details outlined v-model="editedItem.MobilisationCostText" label="Mobilisation Notes"></v-textarea>
                  </v-col>
                  <v-col cols="12" class="py-0" v-if="!hideCosts">
                    <v-checkbox label="Demobilisation" dense hide-details v-model="hasDemobilisationCost"></v-checkbox>
                  </v-col>
                  <v-col cols="12" class="pt-0" v-if="hasDemobilisationCost && !hideCosts">
                    <v-row>
                      <v-col cols="6">
                        <v-select
                          dense
                          hide-details="auto"
                          v-model="editedItem.DemobilisationCurrency"
                          item-text="Value"
                          item-value="Key"
                          :items="allCurrencies"
                          outlined
                          label="Demob Currency"
                        ></v-select>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field hide-details dense outlined type="number" v-model.number="editedItem.DemobilisationCost" label="Demob Cost"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" v-if="hasDemobilisationCost && !hideCosts">
                    <v-textarea hide-details outlined v-model="editedItem.DemobilisationCostText" label="Demobilisation Notes"></v-textarea>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea hide-details outlined v-model="editedItem.Comment" label="General Comments"></v-textarea>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">
                Cancel
              </v-btn>
              <v-btn color="blue darken-1" text @click="save">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="headline">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.IncludedInDayRate="{ item }">
      <v-icon color="success" v-if="item.IncludedInDayRate">mdi-check</v-icon>
    </template>
    <template v-slot:item.Cost="{ item }"> {{ getDisplayCost(item) }} </template>
    <template v-slot:item.NumberOfCrew="{ item }"> {{ item.NumberOfCrew ? item.NumberOfCrew : "TBA" }} </template>
    <template v-slot:item.MobilisationCost="{ item }"> {{ getDisplayMobilisationCost(item) }} </template>
    <template v-slot:item.DemobilisationCost="{ item }"> {{ getDisplayDemobilisationCost(item) }} </template>
    <template v-slot:item.actions="{ item }">
      <v-menu top offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text v-bind="attrs" v-on="on">
            <v-icon>
              mdi-dots-vertical
            </v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="editItem(item)">
            <v-list-item-icon>
              <v-icon class="mr-2">
                mdi-pencil
              </v-icon></v-list-item-icon
            >
            <v-list-item-title>Edit</v-list-item-title>
          </v-list-item>
          <v-list-item @click="deleteItem(item)">
            <v-list-item-icon>
              <v-icon>
                mdi-delete
              </v-icon></v-list-item-icon
            >
            <v-list-item-title>Delete</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
    <template v-slot:no-data>
      <span class="text-center ">
        No Items! Click 'Add Item' above
      </span>
    </template>
    <template v-slot:group.header="{ items, isOpen, toggle }">
      <td colspan="9" @click="toggle">
        <span class="text-subtitle primary--text">{{ items[0].Category }}</span>
      </td>
    </template>
  </v-data-table>
</template>
